import type { ReactNode } from 'react';

import {
  FreeTierBackground,
  FreeTierIcon,
  PremiumTierBackground,
  PremiumTierIcon,
} from '@/asset/img';
import { TENANT_CONST } from '@/constant';
import { VStack, cn } from '@/package';
import type { Tenant } from '@/type';

type PlanCardProps = {
  tenant: Tenant;
};

const tierConfig: {
  [key in Tenant['tier']]: {
    label: string;
    Background: ({ className }: { className: string }) => ReactNode;
    Icon: ({ className }: { className: string }) => ReactNode;
  };
} = {
  freetier: {
    label: 'Free',
    Background: ({ className }) => <FreeTierBackground className={className} />,
    Icon: ({ className }) => <FreeTierIcon className={className} />,
  },
  standard: {
    label: 'Enterprise',
    Background: ({ className }) => (
      <PremiumTierBackground className={className} />
    ),
    Icon: ({ className }) => <PremiumTierIcon className={className} />,
  },
};

export const PlanCard = ({ tenant }: PlanCardProps) => {
  const billingUnit = tenant.billingUnit;
  const tier =
    tenant.tier === TENANT_CONST.TIER.STANDARD
      ? tenant.tier
      : billingUnit >= 2
        ? TENANT_CONST.TIER.STANDARD
        : tenant.tier;
  const { label, Background, Icon } = tierConfig[tier];

  return (
    <div className="relative h-[164px] w-[324px] overflow-hidden rounded-md">
      <Background className="absolute top-[-4px] z-1" />
      <VStack className="absolute top-4 right-4 bottom-4 left-4 z-10  bg-transparent">
        <Icon className="translate-x-[-4px] translate-y-[-4px]" />

        <div
          className={cn('text-headline-lg font-semibold text-gray-600', {
            'text-white': tier === 'standard',
          })}
        >
          {label}
        </div>
      </VStack>
    </div>
  );
};
